const getRoutes = () => []
const getModules = () => {}
const getPlugins = () => []

export { getRoutes, getModules, getPlugins }
